import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './About.css';

import team1 from '../assets/profile.jpg';
import team2 from '../assets/profile.jpg';
import team3 from '../assets/profile.jpg';
import team4 from '../assets/profile.jpg';
import logosqr from '../assets/logo_sqr.jpg';
import visionImg from '../assets/visionn.jpeg';
import missionImg from '../assets/missionn.jpeg';

import founderImg from '../assets/founder.jpg';
import cofounderImg from '../assets/co-founder.jpg';

function About() {
  return (
    <div className="about-page">
      {/* ===== Banner Section ===== */}
      <div className="banner">
        <h2>About DevSkillz</h2>
        <p>
          At <strong>DevSkillz</strong>, we are passionate about bridging the gap between 
          education and industry. We don’t just teach — we transform students into 
          confident, job-ready professionals equipped to excel in real-world challenges.
        </p>
      </div>

      {/* ===== Who We Are Section ===== */}
      <div className="who-we-are">
        <Container>
          <Row className="align-items-center my-5">
            <Col md={6}>
              <h3>Who We Are</h3>
              <p>
                DevSkillz is a leading <strong>tech training and career development institute</strong>, 
                empowering students across India with in-demand skills in Full Stack 
                Development, Data Science, Cloud, AI/ML, and more.
              </p>
              <p>
                With experienced mentors, structured courses, and hands-on learning, 
                we ensure that every student grows from a beginner into a professional.
              </p>
            </Col>
            <Col md={6} className="text-center">
              <img
                src={logosqr}
                alt="Who We Are"
                className="info-img"
              />
            </Col>
          </Row>
        </Container>
      </div>

      {/* ===== Vision & Mission ===== */}
      <div className="us">
        <Container>
          <Row className="align-items-center my-5">
            <Col md={6} className="text-center">
              <img 
                src={visionImg}
                alt="Vision" 
                className="info-img"
              />
            </Col>
            <Col md={6}>
              <h3>Our Vision</h3>
              <p>
                To become a <strong>leading EdTech and training company</strong>, 
                transforming learners into skilled professionals and helping them 
                achieve their dream jobs in top companies.
              </p>
            </Col>
          </Row>

          <Row className="align-items-center my-5 flex-md-row-reverse">
            <Col md={6} className="text-center">
              <img 
                src={missionImg} 
                alt="Mission" 
                className="info-img"
              />
            </Col>
            <Col md={6}>
              <h3>Our Mission</h3>
              <p>
                To <strong>equip students with industry-ready skills</strong> and mentor them 
                towards successful careers, ensuring they stand out in competitive job markets.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ===== Our Values ===== */}
      <div className="values">
        <Container>
          <h3 className="text-center mb-4">Our Core Values</h3>
          <Row>
            <Col md={4}>
              <div className="value-box">
                <h4>Integrity</h4>
                <p>We believe in transparent, honest, and ethical teaching practices.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="value-box">
                <h4>Innovation</h4>
                <p>We constantly adapt and bring the latest tools, frameworks, and methods to our classrooms.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="value-box">
                <h4>Student Success</h4>
                <p>Every student’s success is our success. We mentor beyond just training.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ===== Why Choose Us ===== */}
      <div className="choose-us">
        <Container>
          <h3 className="text-center mb-4">Why Choose DevSkillz?</h3>
          <ul className="choose-list">
            <li> Expert mentors from top companies</li>
            <li> Hands-on live projects & case studies</li>
            <li> 1-on-1 guidance and doubt clearing sessions</li>
            <li> Placement support with mock interviews</li>
            <li> A supportive learning community across India</li>
          </ul>
        </Container>
      </div>

      {/* ===== Team Section ===== */}
      <div className="team">
        {/* <h1 className="text-center mb-4">Meet Our Team</h1> */}
        <Container>
          <Row className="justify-content-center">
            {[
              // { img: founderImg, name: "MA Subhan", role: "Founder" },
              // { img: cofounderImg, name: "MD Ishaq", role: "Co-Founder" },
              // { img: team3, name: "Rohit Kumar", role: "Tech Lead" },
              // { img: team4, name: "Neha Verma", role: "Placement Coordinator" }
            ].map((member, index) => (
              <Col md={3} sm={6} key={index} className="team-member">
                <img src={member.img} alt={member.name} />
                <h4>{member.name}</h4>
                <p>{member.role}</p>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default About;
